import { Fragment, useState, useEffect, useRef } from 'react';
import { styled, Box, Menu, MenuItem, Divider, IconButton, InputBase, InputAdornment, CircularProgress, Skeleton } from '@mui/material';
import Icon from 'app/components/Icon';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useToast } from 'app/hooks/useToast';
import { useWindowSize } from "app/hooks/useWindowSize";
import { topBarHeight } from 'app/utils/constant';
import Api from 'app/utils/Api';
import interval from '../../../config/interval';
import CounterAction from 'app/redux/actions/CounterActions';
import ItemList from 'app/components/ItemList';
import Heading from 'app/components/Heading';
import Avatar from 'app/components/Avatar';
//import Loading from 'app/components/Loading';
import Timer from 'app/components/Timer';
import PhotoUploader from 'app/views/dashboard/components/PhotoUploader';

const ContentBox = styled(Box)(({ theme, height }) => ({ height: height+"px" }));

const Messages = ({ items = null, initLoading =false, ...props }) => {

    const user = useSelector((store) => store.auth.user || {});
    const counter = useSelector((store) => store.counter);
    const dispatch = useDispatch();
    const toast = useToast();
    const messRef = useRef();

    //const { palette } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const windowSize = useWindowSize();
    const [isMbl, setIsMbl] = useState(0);
    const [headerHight,setHeaderHight] = useState(0);
    const [sending, setSending] = useState(false);
    const [userId,setUserId] = useState(0);
    const [username,setUsername] = useState(null);
    const [userData,setUserData] = useState({});
    const [data,setData] = useState({});
    const [loaded,setLoaded] = useState(false);
    const [loading,setLoading] = useState(false);
    const [allowChat,setAllowChat] = useState(false);
    const [messages,setMessages] = useState([]);
    const [since,setSince] = useState(null);
    const [error,setError] = useState(false);
    const [back,setBack] = useState(false);
    const [processing,setProcessing] = useState(null);
    const [readIds,setReadIds] = useState([]);
    const [anchorEl, setAnchorEl] = useState({});
    const [deleted,setDeleted] = useState([]);
    const boxHeight = windowSize.height-topBarHeight-headerHight-1;
    //const [lastMessage,setLastMessage] = useState(null);

    let Smiles = {
        'grinningeyes': '😁',
        'tears-joy': '😂',
        'open-mouth': '😃',
        'open-mouth-2': '😄',
        'open-mouth-coldsweat': '😅',
        'open-mouth-tightly': '😆',
        'winking': '😉',
        'smiling': '😊',
        'delicious-food': '😋',
        'relieved': '😌',
        'heart-shaped': '😍',
        'smirking': '😏',
        'unamused': '😒',
        'cold-sweat': '😓',
        'pensive': '😔',
        'confounded': '😖',
        'throwing-kiss': '😘',
        'kissing-closed': '😚',
        'stuck-out-winking': '😜',
        'stuck-out-tightly': '😝',
        'disappointed': '😞',
        'angry': '😠',
        'pouting': '😡',
        'crying': '😢',
        'persevering': '😣',
        'triumph': '😤',
        'disappointed-relieved': '😥',
        'fearful': '😨',
        'weary': '😩',
        'sleepy': '😪',
        'tired': '😫',
        'loudly-crying': '😭',
        'screaming-fear': '😱',
        'astonished': '😲',
        'flushed': '😳',
        'dizzy': '😵',
        'medical-mask': '😷',
        'halo': '😇',
        'horns': '😈',
        'sunglasses': '😎',
        'neutral': '😐',
        'out-mouth': '😶',
    };

    const [msg,setMsg] = useState('');

    useEffect(()=>{
        setIsMbl(windowSize.width <=560 ? 1 : 0)
    },[windowSize]);
    
    useEffect(()=>{
        let state = location?.state || {}; 
        let _user = state?.ID ? state : (state?.user || {});
        let _uname = _user?.username || (params?.username || null);
        if( state?.user ) delete state.user;
        
        if( _uname && _uname === username ) return false; 
        
        if( _uname && user?.username && user?.username === _uname){
            navigate(`/dashboard/messages`);
            return false;
        }

        setUsername(_uname);
        setUserId(_user?.ID || 0);
        setData(state?.ID ? {} : state);
        setUserData(_user);
        setLoaded(false);
     //   alert(JSON.stringify(location.state)+'/'+JSON.stringify(params));
    },[location,params]);

    useEffect(()=>{
        if( items )
            setMessages(items);
        else {
            if( username ){
                getChat(0, username,userId,data);
                if( isMbl ) setBack(true);
            }
        }
    },[username]);

    const onMenuClick = (event,type) => setAnchorEl(ps=>({...ps, [type]: event.currentTarget}));
    const onMenuClose = (type) => setAnchorEl(ps=>({...ps, [type]: null}));

    const openUser = (user) => navigate(`/user/${user?.username}`, {state: user});
    const sendMsg = async(type=1, file=null) =>{
        let text = msg.trim();

        if( !(text !== '' || file) || sending ) return ;
        setSending(true);
        
        let res, url = `chat/send/${userData?.ID}`;
        if ( type === 2 )
            res = await Api.upload(url, 'image', [file], {text:''});
        else
            res = await Api.post(url, { text });
        setSending(false);

        if( res.success ){
            setMsg('');
           // setLastMessage({ id: userData?.ID, data:{ type: res.data.type, message: res.data.message, time: res.data.time, timestamp: res.data.timestamp}});
            appendMsg([res.data]);
            scrollChat(1);
        } else
            toast.error(res.message);
    }

    const selectSmile =(sk,sml) => {
        let _txt = msg.trim();
        setMsg(_txt === '' ? sml : `${_txt} ${sml}`);
    } 

    const userAction = (act) =>{

        if( act === 'profile'){
            onMenuClose('menu');
            openUser(userData);
            return false;
        }
        
        if( processing ) return;
        setProcessing(act);
        /*
        setTimeout(()=>{
            setProcessing(null);
            onMenuClose('menu');

            setUsername(null);
            setUserId(0);
            setDeleted(ps=>([...ps,...[userId]]));
            window.history.pushState([], "", "/dashboard/messages");
        },2000);
        */
        Api.get(`chat/action/${act}/${userId || 0}`).then(res=>{
            setProcessing(null);
            onMenuClose('menu');
            if( res.success ){
                setUsername(null);
                setUserId(0);
                setDeleted(ps=>([...ps,...[userId]]));
                window.history.pushState([], "", "/dashboard/messages");
            } else
                toast.error(res.message);
        });
    }

    const getChat = (tp, username, user_id, data, snce ) =>{
        
        if( !tp ){
            setLoaded(false);
            setLoading(true);
            setMessages([]);
            setError(false);
            setAllowChat(false);
            setSince(null);
        }
        
        var _url = `chat/get/${user_id ? user_id : username+'?type=username'}`;
        if( snce ) 
            _url = `${_url}${_url.includes('?') ? '&' : '?'}since=${snce}`;

        Api.get(_url).then(res=>{
            setLoading(false); 

            if( res.success ){
                setLoaded(true);
                setSince(res?.data?.datetime);
                setAllowChat(res?.data?.allow || false);
                var msgs = res.data?.list || [];
                if( tp === 1)
                    appendMsg(msgs);
                else {
                    setMessages(msgs);   
                    if( res?.data?.user ){
                        setUserId(res?.data?.user?.ID || 0);
                        setUserData(res?.data?.user || {});
                    }
                }
                if( msgs.length > 0 )
                    scrollChat(0);
            } else
                setError(res?.message || "Unable to load messages");
        });
    }

    const scrollChat = (s) => {
        if( messRef?.current ){
            setTimeout(()=>{
                messRef.current.scrollTop = messRef.current?.scrollHeight || 0;
            },100);
        }
    }
    const appendMsg = (msgs) =>{
        var list = {};
        messages.map(msg=>{
            list[msg.ID] = msg;
            return msg;
        });
        msgs.map(msg=>{
            list[msg.ID] = msg;
            return msg;
        });
        if( msgs.length > 0 )
            setMessages(Object.values(list));
    }

    const onClick = (item) => {
        if( isMbl ) setBack(true);
        setTimeout(()=>{
            setReadIds(ps=>([...ps,...[item.uuid]]));
        },[5000]);
        navigate(`/dashboard/messages/${item.user.username}`, {state: item});

        if( props?.onClick ) props?.onClick(item);
    }

    const onBack = () =>{
        setBack(false);
        navigate(`/dashboard/messages`);
    }

    const onInterval =(s) =>{
        if( since && username && userId && data )
            getChat(1, username,userId,data,since);            
    }

    const renderTime = (msg) =>{
        return <b>{msg.time}</b>;
    }

    const renderItem = (item, idx, sk = 0, tp = 0) =>{

        if( sk ){
            return <div className={`message-items item`} key={`chatu_${tp}_${idx}`}>
                <div className="pht">
                    <Skeleton variant="circular" width={38} height={38}/>
                </div>
                <div className='info'>
                    <div>
                        <b><Skeleton variant="rounded" style={{ borderRadius:"5px" }} width={idx % 2 === 0 ? 40 : 60} height={14} /></b>
                        <span><Skeleton variant="text" width={idx % 3 === 0 ? 40 : 50} height={16} /></span>
                    </div>
                    <p>
                        <Skeleton variant="rounded" style={{ borderRadius:"5px" }} width={idx % 3 === 0 ? 160 : (idx % 2 === 0 ? 90 : 120)} height={11} />
                    </p>
                </div>
            </div>
        };

        if( !item?.user?.username || (deleted || []).includes(item?.user?.ID || 0) ) return null;

        let usr = item?.user, unread = !readIds.includes(item?.uuid) && item.unread > 0 ? 1 : 0;
        return <div key={`chatu_${tp}_${idx}`} className={`message-items item${userId === item?.user?.ID ? ' act' : ''}${item?.online ? ' onli' : ''}`} onClick={()=>onClick(item)}>
            <div className="pht">
                <Avatar size="38" name={`${usr.firstname} ${usr.lastname}`} src={usr.image} />
                <span className="onl"></span>
            </div>
            <div className={`info${unread ? ' actv' : ''}`}>
                <div>
                    <b>{usr.firstname}</b>
                    <span>{item.time}</span>
                </div>
                <p>
                    {item.type === "S" ? "You: ": ""}{item.message.includes('image:') ? '[image]' : item.message.replace('icon:','')}
                    <span className="unr">{item.unread > 99 ? 99 : item.unread}</span>
                </p>
            </div>
        </div>
    }

    const renderMenu = () => {
        let menuOpen = Boolean(anchorEl?.menu || false);
        return (
            <Fragment>
                <IconButton
                  onClick={e=>onMenuClick(e,'menu')}
                  size="small"
                  style={{ padding: "5px", width:"30px", cursor:'pointer' }}
                  aria-controls={menuOpen ? 'chat-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={menuOpen ? 'true' : undefined}
                >
                    <Icon>ellipsis-v</Icon>
                </IconButton>
                <Menu
                    anchorEl={anchorEl?.menu}
                    id="chat-menu"
                    open={menuOpen}
                    onClose={e=>onMenuClose('menu')}
                    PaperProps={{
                      elevation: 0,
                      className:"message-chat-menu",
                      sx: {
                        
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={()=>userAction('profile')}>
                        <Icon size={15}>id-card</Icon>
                        View Profile
                    </MenuItem>   
                    <Divider />
                    <MenuItem onClick={()=>userAction('delete')}>
                        {processing === 'delete' ? <CircularProgress color="inherit" size={18} style={{ marginRight:"10px" }} /> : <Icon size={15}>trash</Icon>}
                        Delete Chat
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={()=>userAction('block')}>
                        {processing === 'block' ? <CircularProgress color="inherit" size={18} style={{ marginRight:"10px" }} /> : <Icon size={15}>ban</Icon>}
                        Block User
                    </MenuItem>
                  
                </Menu>
            </Fragment>
        );
    }

    const renderSmiles = () => {
        let menuOpen = Boolean(anchorEl?.smiles || false)
        return (
            <Fragment>
                <IconButton
                  onClick={e=>onMenuClick(e,'smiles')}
                  size="small"
                  style={{ padding: 0, cursor:'pointer' }}
                  aria-controls={menuOpen ? 'smiles-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={menuOpen ? 'true' : undefined}
                >
                    <Icon>smile</Icon>
                </IconButton>
                <Menu
                    anchorEl={anchorEl?.smiles}
                    id="smiles-menu"
                    open={menuOpen}
                    onClose={e=>onMenuClose('smiles')}
                    onClick={e=>onMenuClose('smiles')}
                    PaperProps={{
                      elevation: 0,
                      className:"message-smile-menu",
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                >
                    <div className="smcntr">
                        {Object.entries(Smiles).map(([sk,sic])=><IconButton className="bt-sm" key={`smile_${sk}`} onClick={()=>selectSmile(sk,sic)}>{sic} </IconButton>)}
                    </div>
                </Menu>
            </Fragment>
        );
    }

    const renderMsgUser = (msg) => {

        var _user = {};
        if( msg.type === 'I')
            _user = { name: `${userData?.firstname} ${userData.lastname}`, image: userData?.image, id: userData?.ID };
        else
            _user = { name: `${user?.firstname} ${user.lastname}`, image: user?.image, id: user?.ID  };

        return <div className="pht">
            <Avatar size="40" name={_user.name} src={_user.image} />
        </div>
    }

    const renderMessage = (_msg) =>{
        
        let mt = '';
        if( _msg.includes("image:") )
            mt = 'img';
        if( _msg.includes("icon:") )
            mt = 'sym';

        _msg = _msg.replace('image:','').replace('icon:','').trim();

        if( mt === 'img' ){
            _msg = <img class="Chat" src={_msg}/>
        }

        return <div className={`txt ${mt}`}>{_msg}</div>;

    }
    const renderChat = () => {
        return <Fragment>
            <Timer time={interval?.chat || 60} onInterval={s=>onInterval(s)}/>
            
            <Box className="messages" ref={messRef}>
                {messages.sort((a, b) => a?.timestamp > b?.timestamp ? 1 : -1).map(msg=>{
                    var _msg = (msg?.message || '').trim();
                    return <div key={`msg_${userId}_${msg.ID}`} className={`item item_${msg.type}`}>
                        {renderMsgUser(msg)}                        
                        <div className="msg">
                            {_msg !== '' && renderMessage(_msg)}
                            <div className="tm">
                                {msg.read > 0 && msg.type === 'S' && <Icon size={10} color="green">check</Icon>}
                                {renderTime(msg)}
                            </div>
                        </div>
                    </div>
                })} 
            </Box>

            {allowChat && <div className="ftr">

                <div className="msgbox">
                    <InputBase
                        value={msg}
                        placeholder="Write message ..."
                        inputProps={{ 'aria-label': 'Write message ...' }}
                        onChange={(e)=>setMsg(e.target.value || '')}
                        onKeyDown={(e)=>{ if(e.keyCode === 13) sendMsg(); }}
                        endAdornment={
                          <InputAdornment position="end">

                            <PhotoUploader 
                                title="Photo"
                                heading="Add Image"
                                icon="camera"
                                crop={false}
                                camera={true}
                                btnText="Send"
                                onSuccess={res=>{
                                    if(res?.file) sendMsg(2,res.file);
                                }}
                                button={props=><Icon style={{ marginRight:"15px", cursor:"pointer" }} size="18px" {...props}>camera</Icon>}
                            />

                            {renderSmiles()}
                            <LoadingButton className="snd" disabled={msg.trim() === ''} loading={sending} onClick={sendMsg}>
                                <Icon size={18}>paper-plane</Icon>
                            </LoadingButton>
                          </InputAdornment>
                        }
                    />
                </div>
            </div>}
        </Fragment>;
    }

    if( items ){
        return <Fragment>
            {(initLoading ? [1,2,3,4,5,6,7,8,9,10,11,12] : messages).map((item,idx)=>renderItem(item, idx, initLoading,1))}
        </Fragment>
    }

    return (
        <Fragment>
            <Heading icon="envelope" mb={0} border="1" bg="#FFF" counter={0} onLayout={l=>setHeaderHight(l.height)}>Messages</Heading>
            <ContentBox className="messages_container" height={boxHeight}>
                <div className={`lft-pnl${!back || !isMbl ? ' shw' : ''}${isMbl ? ' mb' : ''}`}>
                    <ItemList
                        url={`chat/list`}
                        emptyText="No chat found" 
                        errorMargin={20}
                        searchBox={true}
                        columns={1} 
                        limit={15}
                        since={true}
                        sinceTime={interval?.messages || 60}
                        height={boxHeight}
                        stickyHeader={true}
                        filterItems={data=>{
                            /*
                            if( lastMessage?.id ){
                                data = data.map(msg=>{
                                    if( msg.uuid == lastMessage?.id ){
                                        msg = {...msg, ...lastMessage.data};
                                    }
                                    return msg;
                                }) 
                                setLastMessage(null);
                            }
                            */
                            data = data.sort((a, b) => b.timestamp - a.timestamp);
                            return data;
                        }}
                        skeleton={(item,idx)=>renderItem(item,idx,1,0)}
                        renderItem={(item,idx)=>renderItem(item,idx,0,0)}
                        onRemove={()=>{ 
                            dispatch(CounterAction({ messages:(counter?.messages || 0)-1}));  
                        }}
                        onLoad={(total, data, error, res, sts)=>{
                            if( res && res.list && !error && res.list.length > 0){
                                res.list.map(d=>{
                                    if( d.uuid === userId ) setData(d);
                                    setReadIds(ps=>ps.filter(id=>id !== d?.uuid));
                                    return d;
                                })
                            }
                            dispatch(CounterAction({messages:total}));
                            if( windowSize.width > 560 && !params?.username && !sts && res?.list && res.list.length>0)
                                onClick(res.list[0]);
                        }}
                        onActionCall={(res,error, url, item)=>{
                            if( error )
                                toast.error(error);
                        }}
                    />
                </div>
                <div className={`rgt-pnl${back || !isMbl ? ' shw' : ''}${isMbl ? ' mb' : ''}`}>
                    {userId > 0 && userData?.ID && <div className={`header${data?.online ? ' on' : ''}${isMbl && back ? ' bt' : ''}`}>
                        {isMbl > 0 && back > 0 && <button className="back" onClick={()=>onBack(false)} type="button"><Icon>angle-left</Icon></button>}
                        <div className="pht" onClick={()=>openUser(userData)}>
                            <Avatar size="40" name={`${userData.firstname} ${userData.lastname}`} src={userData.image} />
                        </div> 
                        <div className="info">
                            <b className="name" onClick={()=>openUser(userData)}>{userData?.firstname} {userData?.lastname}</b>
                            <span className="time"><Icon size={10}>circle</Icon> {data.utime || "offline"}</span>
                        </div> 
                        <div className="menu">
                            {renderMenu()}
                        </div>    
                    </div>}
                    {!loaded && loading ? 
                        <div className="messages">
                            <div className={`item item_I`}>
                                <div className="pht">
                                    <Skeleton variant="circular" width={40} height={40}/>
                                </div>
                                <div className="msg">
                                    <Skeleton variant="rounded" style={{ borderRadius:"5px", marginTop:"-3px" }} width="100px" height={32} />
                                    <div className="tm">
                                        <Skeleton variant="text" width={35} height={16} />
                                    </div>
                                </div>
                            </div>
                            <div className={`item item_I`}>
                                <div className="pht">
                                    <Skeleton variant="circular" width={40} height={40}/>
                                </div>
                                <div className="msg">
                                    <Skeleton variant="rounded" style={{ borderRadius:"5px", marginTop:"-3px" }} width="200px" height={32} />
                                    <div className="tm">
                                        <Skeleton variant="text" width={35} height={16} />
                                    </div>
                                </div>
                            </div>
                            <div className={`item item_S`}>
                                <div className="pht">
                                    <Skeleton variant="circular" width={40} height={40}/>
                                </div>
                                <div className="msg">
                                    <Skeleton variant="rounded" style={{ borderRadius:"5px", marginTop:"-3px" }} width="100px" height={32} />
                                    <div className="tm">
                                        <Skeleton variant="text" width={35} height={16} />
                                    </div>
                                </div>
                            </div>
                            <div className={`item item_I`}>
                                <div className="pht">
                                    <Skeleton variant="circular" width={40} height={40}/>
                                </div>
                                <div className="msg">
                                    <Skeleton variant="rounded" style={{ borderRadius:"5px", marginTop:"-3px" }} width="250px" height={32} />
                                    <div className="tm">
                                        <Skeleton variant="text" width={35} height={16} />
                                    </div>
                                </div>
                            </div>
                            <div className={`item item_S`}>
                                <div className="pht">
                                    <Skeleton variant="circular" width={40} height={40}/>
                                </div>
                                <div className="msg">
                                    <Skeleton variant="rounded" style={{ borderRadius:"5px", marginTop:"-3px" }} width="150px" height={32} />
                                    <div className="tm">
                                        <Skeleton variant="text" width={35} height={16} />
                                    </div>
                                </div>
                            </div>
                            <div className={`item item_S`}>
                                <div className="pht">
                                    <Skeleton variant="circular" width={40} height={40}/>
                                </div>
                                <div className="msg">
                                    <Skeleton variant="rounded" style={{ borderRadius:"5px", marginTop:"-3px" }} width="90px" height={32} />
                                    <div className="tm">
                                        <Skeleton variant="text" width={35} height={16} />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                     : <Fragment>
                        {!loading && (error || !username) 
                            ? <div className="nocontent">{error && <b>Chat not found !</b>}</div>
                            : renderChat()
                        }
                    </Fragment>}
                </div>            
            </ContentBox>
        </Fragment>
    );
};

export default Messages;
